import { switchAnatomy as parts } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const helpers = createMultiStyleConfigHelpers(parts.keys)

export default helpers.defineMultiStyleConfig({
  defaultProps: {
    colorScheme: 'primary',
  },
})
